<template>
  <el-dialog
    :title="$t('productPriceRule.edit')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <el-form ref="editForm" :model="editProductPriceRuleInfo" :rules="rules" label-width="120px">
      <el-form-item :label="$t('productPriceRule.strategyName')" prop="ruleName" required>
        <el-input
          v-model="editProductPriceRuleInfo.ruleName"
          :placeholder="$t('productPriceRule.requiredRuleName')"
          style="width: 100%">
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('productPriceRule.strategyType')" prop="ruleType" required>
        <el-select
          v-model="editProductPriceRuleInfo.ruleType"
          :placeholder="$t('productPriceRule.requiredRuleType')"
          style="width: 100%">
          <el-option disabled :label="$t('productPriceRule.requiredRuleType')" value=""></el-option>
          <el-option :label="$t('productPriceRule.normal')" value="1001"></el-option>
          <el-option :label="$t('productPriceRule.supplyChain')" value="2002"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('productPriceRule.sellingPrice')" prop="priceBase" required>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="editProductPriceRuleInfo.priceBase"
              :placeholder="$t('common.requiredSelect')"
              style="width: 100%">
              <el-option disabled :label="$t('common.requiredSelect')" value=""></el-option>
              <el-option :label="$t('productPriceRule.costPrice')" value="1"></el-option>
              <el-option
                v-if="editProductPriceRuleInfo.ruleType === '2002'"
                :label="$t('productPriceRule.sellingPrice')" value="2"></el-option>
              <el-option
                v-if="editProductPriceRuleInfo.ruleType === '2002'"
                :label="$t('productPriceRule.marketPrice')" value="3"></el-option>
              <el-option
                v-if="editProductPriceRuleInfo.ruleType === '2002'"
                :label="$t('productPriceRule.ownerPrice')" value="4"></el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <el-input
              v-model="editProductPriceRuleInfo.price"
              :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 市场价 -->
      <el-form-item :label="$t('productPriceRule.marketPrice')" prop="otPriceBase" required>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="editProductPriceRuleInfo.otPriceBase"
              :placeholder="$t('common.requiredSelect')"
              style="width: 100%">
              <el-option disabled :label="$t('common.requiredSelect')" value=""></el-option>
              <el-option :label="$t('productPriceRule.costPrice')" value="1"></el-option>
              <el-option v-if="editProductPriceRuleInfo.ruleType === '2002'" :label="$t('productPriceRule.sellingPrice')" value="2"></el-option>
              <el-option v-if="editProductPriceRuleInfo.ruleType === '2002'" :label="$t('productPriceRule.marketPrice')" value="3"></el-option>
              <el-option v-if="editProductPriceRuleInfo.ruleType === '2002'" :label="$t('productPriceRule.ownerPrice')" value="4"></el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <el-input v-model="editProductPriceRuleInfo.otPrice" :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 业主价 -->
      <el-form-item :label="$t('productPriceRule.ownerPrice')" prop="ownerPriceBase" required>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="editProductPriceRuleInfo.ownerPriceBase"
              :placeholder="$t('common.requiredSelect')"
              style="width: 100%">
              <el-option disabled :label="$t('common.requiredSelect')" value=""></el-option>
              <el-option :label="$t('productPriceRule.costPrice')" value="1"></el-option>
              <el-option v-if="editProductPriceRuleInfo.ruleType === '2002'" :label="$t('productPriceRule.sellingPrice')" value="2"></el-option>
              <el-option v-if="editProductPriceRuleInfo.ruleType === '2002'" :label="$t('productPriceRule.marketPrice')" value="3"></el-option>
              <el-option v-if="editProductPriceRuleInfo.ruleType === '2002'" :label="$t('productPriceRule.ownerPrice')" value="4"></el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <el-input v-model="editProductPriceRuleInfo.ownerPrice" :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <!--
      <el-form-item :label="$t('productPriceRule.memberPrice')" prop="vipPriceBase" required>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="editProductPriceRuleInfo.vipPriceBase"
              :placeholder="$t('common.requiredSelect')"
              style="width: 100%">
              <el-option disabled :label="$t('common.requiredSelect')" value=""></el-option>
              <el-option :label="$t('productPriceRule.costPrice')" value="1"></el-option>
              <el-option
                v-if="editProductPriceRuleInfo.ruleType === '2002'"
                :label="$t('productPriceRule.sellingPrice')" value="2"></el-option>
              <el-option
                v-if="editProductPriceRuleInfo.ruleType === '2002'"
                :label="$t('productPriceRule.marketPrice')" value="3"></el-option>
              <el-option
                v-if="editProductPriceRuleInfo.ruleType === '2002'"
                :label="$t('productPriceRule.ownerPrice')" value="4"></el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <el-input
              v-model="editProductPriceRuleInfo.vipPrice"
              :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      -->

      <!-- 物业抵扣金 -->
      <el-form-item :label="$t('productPriceRule.propertyDeduction')" prop="deduction" required>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-input v-model="editProductPriceRuleInfo.deduction" :placeholder="$t('productPriceRule.percentage')">
              <template slot="append">%</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="editProductPriceRule">
          {{$t('common.save')}}
        </el-button>
        <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { updateProductPriceRule } from '@/api/goods/productPriceRuleApi'

export default {
  name: 'EditProductPriceRule',
  data() {
    return {
      dialogVisible: false,
      editProductPriceRuleInfo: {
        ruleId: '',
        ruleName: '',
        price: '',
        otPrice: '',
        ownerPrice: '',
        deduction: '',
        ruleType: '',
        priceBase: '1',
        otPriceBase: '1',
        ownerPriceBase: '1',
        shopId: ''
      },
      rules: {
        ruleName: [
          { required: true, message: this.$t('productPriceRule.requiredRuleName') || '请输入策略名称', trigger: 'blur' }
        ],
        ruleType: [
          { required: true, message: this.$t('productPriceRule.requiredRuleType') || '请选择策略类型', trigger: 'change' }
        ],
        priceBase: [
          { required: true, message: this.$t('common.requiredSelect') || '请选择', trigger: 'change' }
        ],
        otPriceBase: [
          { required: true, message: this.$t('common.requiredSelect') || '请选择', trigger: 'change' }
        ],
        ownerPriceBase: [
          { required: true, message: this.$t('common.requiredSelect') || '请选择', trigger: 'change' }
        ],
        // vipPriceBase: [
        //   { required: true, message: this.$t('common.requiredSelect') || '请选择', trigger: 'change' }
        // ],
        deduction: [
          { required: true, message: this.$t('productPriceRule.requiredDeduction') || '物业抵扣金不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.editProductPriceRuleInfo = Object.assign({}, row)
      // 强制转为字符串，防止后端返回数字类型导致 v-if 严格比较失败
      this.editProductPriceRuleInfo.ruleType = String(this.editProductPriceRuleInfo.ruleType || '')
      this.editProductPriceRuleInfo.priceBase = String(this.editProductPriceRuleInfo.priceBase || '1')
      this.editProductPriceRuleInfo.otPriceBase = String(this.editProductPriceRuleInfo.otPriceBase || '1')
      this.editProductPriceRuleInfo.ownerPriceBase = String(this.editProductPriceRuleInfo.ownerPriceBase || '1')
      // this.editProductPriceRuleInfo.vipPriceBase = String(this.editProductPriceRuleInfo.vipPriceBase || '1')
      this.dialogVisible = true
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.editProductPriceRuleInfo = {
        ruleId: '',
        ruleName: '',
        price: '',
        otPrice: '',
        ownerPrice: '',
        deduction: '',
        ruleType: '',
        priceBase: '1',
        otPriceBase: '1',
        ownerPriceBase: '1',
        shopId: ''
      }
    },
    editProductPriceRule() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.editProductPriceRuleInfo.shopId = getShopId()
          updateProductPriceRule(this.editProductPriceRuleInfo)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('common.saveSuccess'))
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.msg || '更新失败')
              }
            })
            .catch(error => {
              console.error('更新失败:', error)
              this.$message.error(error.msg || '更新失败')
            })
        }
      })
    }
  }
}
</script>
